import React from "react";
import StylistOnBoardingComponent from "../modules/StylistOnBoarding";

function StylistOnBoardingPage(props) {
  return <StylistOnBoardingComponent {...props} />;
}

export default StylistOnBoardingPage;
